import { Fragment } from 'react';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
export function LeftSidebar() {
    return (<Fragment>
      <Mobile />
      <Desktop />
    </Fragment>);
}
